export default "__VITE_ASSET__CdFUX0Gv__"